export default "__VITE_ASSET__CoakQ6IS__"